export default "__VITE_ASSET__BGAv10cb__"